import { FunctionComponent } from 'react'
import { CookWidget } from '@widgets/types'
import SportTableInlineComponents from '@components/SportTableInline'
import { SportTableInlineProps } from './types'
import useSportsStandings from '@hooks/useSportsStandings'

const { Container, Table } = SportTableInlineComponents

const SportTableInline: FunctionComponent<SportTableInlineProps> = ({
  currentSeasonId: seasonId,
  typeOfSport,
  numOfTeams,
  customTitle,
}) => {
  const { data: sportsStandingsData } = useSportsStandings({
    customTitle,
    numOfTeams,
    seasonId,
    typeOfSport,
  })

  if (!sportsStandingsData) {
    return null
  }

  return (
    <Container key={`table-of-${typeOfSport}-season-${seasonId}`}>
      {sportsStandingsData.tables.map(({ title, dataRows, legend }, index) => (
        <Table
          key={`table-of-${typeOfSport}-season-${seasonId}-table-${index}`}
          title={title}
          dataRows={dataRows}
          legend={legend}
          header={sportsStandingsData.header}
          outcomeTypeColors={sportsStandingsData.outcomeTypeColors}
        />
      ))}
    </Container>
  )
}

const widget: CookWidget = {
  kind: ['widget', 'sport', 'table-inline'],
  component: SportTableInline,
}

export default widget
